<template>
    <all-campaigns-base
        companyTypeFilter="webshops"
        :initialCategory="initialCategory"
        :initialSubcategory="initialSubcategory"
        initialTitle="Bästa rabattkoderna online! - E-handel"
        categoryTitle="E-handel |CATEGORY|"
        initialMetaDesc="Rabattkoder online! Här hittar du nya kampanjer och rabatter på allt från barnkläder, hantverkare, inredning mm. till telefonabonnemang och mat!"
        :data="data"
        :paginator="paginator"
        :hide-type-filter="true"
        :hide-city-filter="true">
        <template #heading>
            <expandable-text :max-length="100" :disabled="!$isMobile">
                Är du en av de som gillar att shoppa online? Då har du hamnat rätt! Här hittar du företag som levererar varor och tjänster direkt hem till dig. Luta dig tillbaka och fixa inköpen hemifrån!
            </expandable-text>
        </template>
    </all-campaigns-base>
</template>

<script>
    import AllCampaignsBase from '@/Pages/AllCampaigns/AllCampaigns';

    export default {
        inject: ['$isMobile'],

        props: ['initialCategory', 'initialSubcategory', 'data', 'paginator'],

        components: { AllCampaignsBase },
    }
</script>
